/* Nuvò · Schede prodotto · galleria, quantità, «Aggiungi» delle card correlate */
(function () {
  if (window.__nuvoPdp) return;
  window.__nuvoPdp = true;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  function initGallery(g) {
    var slides = Array.prototype.slice.call(g.querySelectorAll('[data-npdp-slide]'));
    var thumbs = Array.prototype.slice.call(g.querySelectorAll('[data-npdp-thumb]'));
    var cur = 0;
    function show(i) {
      if (!slides.length) return;
      cur = (i + slides.length) % slides.length;
      slides.forEach(function (s, k) {
        var on = k === cur;
        s.classList.toggle('is-on', on);
        if (!on) {
          var v = s.querySelector('video');
          if (v && v.pause) v.pause();
        }
      });
      thumbs.forEach(function (t, k) { t.classList.toggle('is-on', k === cur); });
    }
    thumbs.forEach(function (t, k) { t.addEventListener('click', function () { show(k); }); });
    var p = g.querySelector('[data-npdp-prev]');
    var n = g.querySelector('[data-npdp-next]');
    if (p) p.addEventListener('click', function () { show(cur - 1); });
    if (n) n.addEventListener('click', function () { show(cur + 1); });
    show(0);
  }

  function initForm(f) {
    var input = f.querySelector('[data-npdp-qty]');
    var out = f.querySelector('[data-npdp-qty-out]');
    function set(v) {
      v = Math.max(1, Math.min(99, v));
      if (input) input.value = v;
      if (out) out.textContent = v;
    }
    var minus = f.querySelector('[data-npdp-minus]');
    var plus = f.querySelector('[data-npdp-plus]');
    if (minus) minus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) - 1); });
    if (plus) plus.addEventListener('click', function () { set((parseInt(input.value, 10) || 1) + 1); });
    var sel = f.querySelector('[data-npdp-var]');
    if (sel) {
      sel.addEventListener('change', function () {
        var o = sel.options[sel.selectedIndex];
        var price = document.querySelector('[data-npdp-price]');
        if (price && o.getAttribute('data-price')) price.innerHTML = o.getAttribute('data-price');
      });
    }
  }

  function initAdd(root_) {
    root_.addEventListener('submit', function (e) {
      var form = e.target;
      if (!form.matches || !form.matches('[data-npdp-add]')) return;
      if (!window.fetch || !window.FormData) return;
      e.preventDefault();
      var btn = form.querySelector('button');
      var label = btn.textContent;
      btn.disabled = true;
      fetch(root() + 'cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      })
        .then(function (r) { if (!r.ok) throw new Error('add'); return r.json(); })
        .then(function () { return fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } }); })
        .then(function (r) { return r.json(); })
        .then(function (cart) {
          btn.textContent = root_.getAttribute('data-npdp-added') || 'Aggiunto';
          document.querySelectorAll('.cart-count-bubble span[aria-hidden], [data-cart-count], .cart-count, .header__cart-count').forEach(function (el) {
            el.textContent = cart.item_count;
          });
          document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
          setTimeout(function () { btn.textContent = label; btn.disabled = false; }, 1800);
        })
        .catch(function () { btn.disabled = false; form.submit(); });
    });
  }

  function start() {
    document.querySelectorAll('[data-npdp-gallery]').forEach(function (g) {
      if (g.__np) return; g.__np = true; initGallery(g);
    });
    document.querySelectorAll('[data-npdp-form]').forEach(function (f) {
      if (f.__np) return; f.__np = true; initForm(f);
    });
    document.querySelectorAll('[data-npdp-abb]').forEach(function (s) {
      if (s.__np) return; s.__np = true; initAdd(s);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
  document.addEventListener('shopify:section:load', start);
})();
